"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var {
  REACT_APP_FUSION_ORIGIN
} = process.env;
var _default = exports.default = _axios.default.create({
  baseURL: REACT_APP_FUSION_ORIGIN
});